import { IconButton } from "@mui/material";
import { TopBarBreadcrumbs } from "../../components/data/DataBreadcrumbs";
import { PersonForm } from "../../components/person/PersonForm";
import { Logout } from "../../icons";
import { logout } from "../../models/Identity";
import { Person } from "../../models/Types";
import { TopAppBar } from "../../nav/AppBar";

export class ProfileForm extends PersonForm {
    protected fetchNew(): boolean {
        return true;
    }

    protected getTypeId(): string {
        return 'Person';
    }

    protected getCmdGet(): string {
        return this.getTypeId() + 'Current';
    }

    protected getCmdPost(): string {
        return super.getCmdPost() + 'Self';
    }

    protected buildPersonItems(entity?: Person) {
        var result = super.buildPersonItems(entity);

        return result.filter((x, i) => i < 2);
    }

    buildButtons(entity?: Person) {
        var result = super.buildButtons(entity);

        return result.filter((x, i) => !i);
    }
}

export default function ProfileMobileForm() {
    return <>
        <TopAppBar left={<TopBarBreadcrumbs title="Главная" />} right={<IconButton onClick={logout}>{Logout}</IconButton>} />

        <ProfileForm id={0} sx={{ p: 1 }} />
    </>;
}